"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function () {
    return _legacy.parse;
  }
});
exports.responseAsOptionProps = responseAsOptionProps;
Object.defineProperty(exports, "stringify", {
  enumerable: true,
  get: function () {
    return _legacy.stringify;
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fieldFrame = _interopRequireDefault(require("@ux/field-frame"));
var _select = _interopRequireDefault(require("@ux/select"));
var _textEntry = _interopRequireDefault(require("@ux/text-entry"));
var _label = require("@ux/label");
var _text = _interopRequireDefault(require("@ux/text"));
var _legacy = require("./legacy");
const _excluded = ["ariaLabels", "children", "className", "intlCallingCodes", "label", "helpMessage", "errorMessage", "onChange", "type", "value", "visualSize"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const UX_TEL_INPUT_CLASSNAME = 'ux-telephone-input';
const UX_TEL_INPUT_LABEL_FLOAT = false;
const UX_TEL_MAX_CALLCODE_LENGTH = 3;
const UX_TEL_CALLCODE_PREFIX = '+';
const DEFAULT_ARIA_LABELS = {
  callingCode: 'Calling code',
  lineNumber: 'Line number'
};

/**
 * Finds API data based on countryKey
 *
 * @param {Array<Object>} codes - Response from the countries API
 * @param {String} countryKey - countryKey search index
 * @returns {Object} - Item from countries API
 */
function codeByCountry() {
  let codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let countryKey = arguments.length > 1 ? arguments[1] : undefined;
  return countryKey && codes.find(code => code.countryKey === countryKey) || {};
}

/**
 * Determines the countryKey based on incoming value against countries API data
 *
 * @param {Array<Object>} codes - Response from the countries API
 * @param {Object} value - Object representing the component value
 * @param {String} [value.countryKey] - countryKey search index
 * @param {String} [value.callingCode] - callingCode search index
 * @returns {String} - countryKey
 */
function bestMatchCountryKey() {
  let codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let {
    countryKey,
    callingCode
  } = arguments.length > 1 ? arguments[1] : undefined;
  const exactMatch = codeByCountry(codes, countryKey);
  if (exactMatch !== null && exactMatch !== void 0 && exactMatch.countryKey) return countryKey;
  const firstMatch = codes.find(code => code.callingCode === callingCode);
  if (firstMatch) return firstMatch.countryKey;
  if (codes.length > 1) return codes[0].countryKey;
  return '';
}

/**
 * Transforms response from common API into props for <option/> elements
 * (https://developer.godaddy.com/doc#!/_v1_countries/getCountries)
 *
 * @param {Array<Object>} intlCallingCodes - Response from the Countries API
 * @returns {Object} - Props for each <option/> element
 */
function responseAsOptionProps(intlCallingCodes) {
  return [].concat(intlCallingCodes).filter(Boolean).map(_ref => {
    let {
      label,
      callingCode,
      countryKey
    } = _ref;
    const children = `${UX_TEL_CALLCODE_PREFIX}${callingCode}`;
    return {
      children,
      label: `${children} ${label}`,
      value: countryKey,
      key: countryKey
    };
  });
}

/**
 * Text input functional component
 * @param {Object} props - Information for the props can be found in the PropTypes below and in TextEntry propTypes
 * @param {Object} [props.ariaLabels] - aria-label configuration
 * @param {Array<Object>} [props.intlCallingCodes] - Data from https://developer.godaddy.com/doc#!/_v1_countries/getCountries
 * @param {String|React.Element} [props.label] - Label for the component
 * @param {String} [props.helpMessage] - Message for the component
 * @param {String} [props.errorMessage] - Error message for the component
 * @param {('sm' | 'md')} [props.visualSize] - Sets component size, defaults to "md"
 * @param {Object} ref - Forwarded ref to TextEntry
 * @returns {React.Component} TelephoneInput component
 */
// eslint-disable-next-line complexity
const TelephoneInput = /*#__PURE__*/_react.default.forwardRef(function TelephoneInput(_ref2, ref) {
  let {
      ariaLabels: _ariaLabels,
      children,
      className,
      intlCallingCodes,
      label,
      helpMessage,
      errorMessage,
      onChange = Function.prototype,
      type = 'tel',
      value = {},
      visualSize = 'md'
    } = _ref2,
    textEntryProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  const ariaLabels = _objectSpread(_objectSpread({}, DEFAULT_ARIA_LABELS), _ariaLabels);
  const {
    id,
    name,
    invalid,
    disabled,
    onBlur,
    required,
    labelExperimentalFloat
  } = textEntryProps || {};
  const helpMessageId = helpMessage && `${id}-help`;
  const errorMessageId = errorMessage && `${id}-error`;
  const selectId = `${id}-select`;

  // Determine if the label should float. Small components don't support floating labels.
  const float = visualSize !== 'sm' && labelExperimentalFloat || UX_TEL_INPUT_LABEL_FLOAT;
  const _onSelectChange = (0, _react.useCallback)((countryKey, meta) => {
    const {
      callingCode
    } = codeByCountry(intlCallingCodes, countryKey);
    onChange(_objectSpread(_objectSpread({}, value), {}, {
      callingCode,
      countryKey
    }), meta);
  }, [onChange, value, intlCallingCodes]);
  const _onInputChange = (0, _react.useCallback)((lineNumber, meta) => onChange(_objectSpread(_objectSpread({}, value), {}, {
    lineNumber
  }), meta), [onChange, value]);
  const options = intlCallingCodes ? responseAsOptionProps(intlCallingCodes).map(optionProps => /*#__PURE__*/_react.default.createElement("option", (0, _extends2.default)({
    key: optionProps.key
  }, optionProps))) : children;
  const hasOptions = Boolean(options && options.length);

  // Find best match given value input
  const selectValue = bestMatchCountryKey(intlCallingCodes, value);
  const classNames = (0, _classnames.default)(`${UX_TEL_INPUT_CLASSNAME}-shell`, `${UX_TEL_INPUT_CLASSNAME}--size-${visualSize}`, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-version": "2400",
    className: classNames
  }, !float && (0, _label.ensureLabelComponent)(label, {
    htmlFor: id,
    required
  }), /*#__PURE__*/_react.default.createElement(_fieldFrame.default, {
    disabled,
    invalid
  }, hasOptions && /*#__PURE__*/_react.default.createElement(_select.default, {
    "aria-label": ariaLabels.callingCode,
    id: selectId,
    name: name,
    onChange: _onSelectChange,
    onBlur: onBlur,
    value: selectValue,
    size: UX_TEL_MAX_CALLCODE_LENGTH + UX_TEL_CALLCODE_PREFIX.length + 1,
    visualSize: visualSize,
    ref: ref
  }, options), hasOptions && /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_textEntry.default, (0, _extends2.default)({}, textEntryProps, {
    type: type,
    "aria-invalid": invalid,
    "aria-errormessage": errorMessageId,
    "aria-describedby": helpMessageId,
    "aria-label": ariaLabels.lineNumber,
    label: float && label,
    onChange: _onInputChange,
    value: value === null || value === void 0 ? void 0 : value.lineNumber,
    visualSize: visualSize,
    ref: ref
  }))), helpMessage && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: helpMessage,
    as: "caption",
    id: helpMessageId,
    emphasis: "passive"
  }), errorMessage && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: errorMessage,
    as: "caption",
    id: errorMessageId,
    emphasis: "critical",
    role: "alert"
  }));
});
TelephoneInput.propTypes = _objectSpread(_objectSpread({}, _textEntry.default.propTypes), {}, {
  /** aria-labels configuration */
  ariaLabels: _propTypes.default.shape({
    callingCode: _propTypes.default.string,
    lineNumber: _propTypes.default.string
  }),
  /** Custom construction for the dropdown */
  children: _propTypes.default.node,
  /** Data from https://developer.godaddy.com/doc#!/_v1_countries/getCountries */
  intlCallingCodes: _propTypes.default.array,
  /** Label for the input */
  label: _propTypes.default.node.isRequired,
  /** Optional message which appears below the input */
  helpMessage: _propTypes.default.string,
  /** Optional error message which appears below the input */
  errorMessage: _propTypes.default.string,
  /** Expected value is an object */
  value: _propTypes.default.shape({
    /** Calling code assigned to the select */
    callingCode: _propTypes.default.node,
    /** Line number assigned to the text-entry */
    lineNumber: _propTypes.default.node,
    /** Identifies the precise country selected */
    countryKey: _propTypes.default.string
  }),
  /** Component size, default is 'md' */
  visualSize: _propTypes.default.oneOf(['sm', 'md'])
});
TelephoneInput.displayName = 'TelephoneInput';
TelephoneInput.responseAsOptionProps = responseAsOptionProps;
var _default = exports.default = TelephoneInput;